// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { userLogsAPI } from "../services/session.service";
import {
  hideSalesPopUp,
  setActiveDashboard,
  setIsWebinarPopActive,
  showSalesPopUp,
  showVideoPopup,
  startHandleItemLoading,
  setSalesPopupContent,
  setVideoPopupContent,
  stopHandleItemLoading,
  setPdfPopupContent,
  showPdfPopup,
} from "../store/auth/action";
import { logAmplitudeEvent } from "./amplitude/functions";
import amplitude from "./amplitude/initiate";
import { createNewTabId, getOrCreateTabId, setActiveTabId } from "./browserTab";
import { getSession } from "./sessionstore";
import { addRecentDashboard } from "../services/recent.service";
import { addSingleRecent } from "../store/auth/action";

// A Platform Dashboard's `url` is an in-app route, not an external link.
function platformRoute(url, clientID, userDetails) {
  const withClient =
    userDetails?.permissions === "HWAI_ADMIN" && clientID !== undefined;
  const prefix = withClient ? `/${clientID}` : "";

  const slug = (url || "")
    .trim()
    .replace(/:clientID\??/g, "")
    .replace(/^\/+|\/+$/g, "");

  const safe = /^[a-z0-9-]+(\/[a-z0-9-]+)*$/i.test(slug);

  return safe ? `${prefix}/${slug}` : prefix || "/";
}

// Fire-and-forget so navigation never waits on it.
function recordRecent(dashboard, clientID, dispatch, strictLogOnly) {
  if (strictLogOnly) return;
  const urlStatus = dashboard?.url?.toLowerCase();
  if (!dashboard?._id || urlStatus === "greyed" || urlStatus === "disabled") return;

  const clientId = clientID ?? getSession("client_id");
  if (!clientId) return;

  addRecentDashboard(getSession("session_hwai"), {
    clientId,
    dashboardId: dashboard._id,
  }).catch(() => {});

  if (dispatch)
    dispatch(
      addSingleRecent({ dashboardId: dashboard, viewedAt: new Date().toISOString() })
    );
}
async function callUserLogAPI(
  productLine,
  triggerType,
  dashboardName,
  standarddashboardName,
  dashboardId,
  clickType,
  userDetails,
  clientname,
  clientID,
  type = null,
  overrideTabId = undefined,
  strictLogOnly = false,
  pulseType = "default"
) {
  try {
    // console.log("log got called", strictLogOnly, "strictLogOnly");
    // console.log(userDetails, "userDetails");
    if (strictLogOnly) {
      triggerType === "WHITEPAPER"
        ? logAmplitudeEvent(
            amplitude,
            `Page is ${pulseType === "Idle" ? "Idle" : "Live"}`,
            {
              triggerType,
              standardDashboardName: standarddashboardName,
              clientName: clientname,
              whitePaperName: dashboardName,
              clientId: clientID,
              whitePaperId: dashboardId,
              targetType: type ?? "DEFAULT",
              eventTimestamp: new Date().toLocaleString("en-US", {
                timeZone: "UTC",
              }),
            },
            undefined
          )
        : logAmplitudeEvent(
            amplitude,
            `Page is ${pulseType === "Idle" ? "Idle" : "Live"}`,
            {
              productLine,
              triggerType,
              standardDashboardName: standarddashboardName,
              clientName: clientname,
              dashboardName,
              clientId: clientID,
              dashboardId,
              targetType: type ?? "DASHBOARD",
              eventTimestamp: new Date().toLocaleString("en-US", {
                timeZone: "UTC",
              }),
            },
            undefined
          );
      return;
    } else {
      triggerType === "WHITEPAPER"
        ? logAmplitudeEvent(
            amplitude,
            "Page Viewed",
            {
              triggerType,
              standardDashboardName: standarddashboardName,
              clientName: clientname,
              whitePaperName: dashboardName,
              clientId: clientID,
              whitePaperId: dashboardId,
              targetType: type ?? "DEFAULT",
              eventTimestamp: new Date().toLocaleString("en-US", {
                timeZone: "UTC",
              }),
            },
            overrideTabId
          )
        : logAmplitudeEvent(
            amplitude,
            "Page Viewed",
            {
              productLine,
              triggerType,
              standardDashboardName: standarddashboardName,
              clientName: clientname,
              dashboardName,
              clientId: clientID,
              dashboardId,
              targetType: type ?? "DASHBOARD",
              eventTimestamp: new Date().toLocaleString("en-US", {
                timeZone: "UTC",
              }),
            },
            overrideTabId
          );
    }
    userLogsAPI(
      triggerType,
      standarddashboardName,
      userDetails,
      clientname,
      dashboardName,
      clickType,
      clientID,
      dashboardId
    );
    // console.log(logresponse, "banner click");
  } catch (err) {
    // console.log(err.message);
  }
}
async function handleItem({
  productLine,
  dashboard,
  clientID,
  userDetails,
  clientName,
  triggerType,
  pathname,
  postItemHandle,
  dispatch,
  navigate,
  setRefetchDynamicCampaigns,
  strictLogOnly = false,
  staticPop = false,
  categoryLabel,
}) {
  // if (!strictLogOnly) if (dispatch) dispatch(startHandleItemLoading());
  const end = () => {
    // console.log("handleItem end");
    if (dispatch) dispatch(stopHandleItemLoading());
    if (strictLogOnly) return;
    if (postItemHandle) postItemHandle();
    return;
  };
  // console.log(dashboard, "received dashboard", clientID, userDetails, clientName, triggerType, pathname, postItemHandle, dispatch, navigate, setRefetchDynamicCampaigns, strictLogOnly);
  const urlStatus = dashboard?.url?.toLowerCase();
  const hasSalesContent = dashboard?.salesContentId;
  const newTabId = undefined;
  // console.log("handleItem check 1");
  // Opens a dashboard's content: PDF-type dashboards (type: "PDF"/"releasenote") show
  // in the reusable PdfViewerPopup overlay instead of navigating away; everything else
  // navigates exactly as before. This is the ONLY thing that changed for PDFs - every
  // tracking call, recordRecent, setActiveDashboard etc. below is untouched, so a PDF
  // dashboard still goes through the exact same branch/log calls it always did, just
  // with its final "open" step swapped from navigate() to the popup.
  const openDashboardOrPdf = (routePath) => {
    if (dashboard?.type === "releasenote" || dashboard?.type === "PDF") {
      dispatch(setPdfPopupContent({ ...dashboard, categoryLabel }));
      dispatch(showPdfPopup());
    } else {
      navigate && navigate(routePath);
    }
  };
  // handle whitepaper
  if (triggerType === "WHITEPAPER") {
    // if (dashboard?.type !== "releasenote" && !strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      dashboard?.type === "releasenote" ? "PDF" : "EXTERNAL_LINK",
      dashboard?.type === "releasenote"
        ? undefined
        : strictLogOnly
        ? undefined
        : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    // console.log("dashboard?.type", dashboard?.type);
    if (dashboard?.type === "releasenote") {
      dispatch(setActiveDashboard(dashboard));
      if (userDetails?.permissions === "HWAI_ADMIN" && clientID !== undefined) {
        openDashboardOrPdf(`/${clientID}/dashboard/${dashboard._id}/WHITEPAPER`);
      } else {
        openDashboardOrPdf(`/dashboard/${dashboard._id}/WHITEPAPER`);
      }
    } else {
      // window.open(dashboard?.url + `?${queryParams.toString()}`, "_blank");
      window.open(dashboard?.url, "_blank");
    }
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    return end();
  }
  // console.log("handleItem check 2");
  // Handle disabled dashboards without sales content
  if (
    urlStatus === "greyed" ||
    (urlStatus === "disabled" && !hasSalesContent)
  ) {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Disabled",
      userDetails,
      clientName,
      clientID,
      urlStatus === "greyed" ? "GREYED" : "NO_SALES_CONTENT",
      undefined,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    // navigate && navigate(`/${clientID || ""}`);
    if (
      userDetails?.permissions === "HWAI_ADMIN" &&
      clientID !== undefined &&
      pathname !== `/${clientID}`
    ) {
      navigate(`/${clientID}`);
    } else if (pathname !== "/" && userDetails?.permissions !== "HWAI_ADMIN") {
      navigate("/");
    }
    return end();
  }
  // console.log("handleItem check 3");
  // Open dashboards in new tab
  if (dashboard?.type === "Open in new tab") {
    // if (!strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "EXTERNAL_LINK",
      strictLogOnly ? undefined : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    recordRecent(dashboard, clientID, dispatch, strictLogOnly);
    // window.open(dashboard?.url + `?${queryParams.toString()}`, "_blank");
    window.open(dashboard?.url, "_blank");
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    return end();
  }
  // console.log("handleItem check 4");
  // Data Cube handling
  if (dashboard?.type === "Data Cube") {
    // if (!strictLogOnly) await preNewTabNavigation()
    const cubeUrl = dashboard?.url?.split("=")[0];
    const email = encodeURIComponent(userDetails?.email ?? "");
    const clientSQLId = getSession("clientSQLId");
    const orgs = getSession("orgs") || [];
    const matchedOrg = orgs?.find((obj) => obj?._id === clientID);
    let userId = userDetails?.userSQLId ?? "";

    if (userDetails?.permissions === "HWAI_ADMIN") {
      userId =
        userId + (dashboard?.customclientauth || matchedOrg?.clientSQLId || "");
    } else if (userDetails?.permissions === "HWAI_USER") {
      userId =
        userId + (dashboard?.customclientauth || clientSQLId || "");
    }
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "EXTERNAL_LINK",
      strictLogOnly ? undefined : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    recordRecent(dashboard, clientID, dispatch, strictLogOnly);
    if (cubeUrl) {
      window.open(
        `${cubeUrl}=${email}${userId ? `&userid=${encodeURIComponent(userId)}` : ""}`,
        "_blank"
      );
    }
    return end();
  }
  if (dashboard?.type === "Download") {
    // if (!strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Downloaded",
      userDetails,
      clientName,
      clientID,
      "DOWNLOAD",
      strictLogOnly ? undefined : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    recordRecent(dashboard, clientID, dispatch, strictLogOnly);
    window.open(dashboard?.url, "_blank");
    return end();
  }
  // Earnings Intelligence is an in-app page rather than an embedded dashboard,
  // so it navigates to its own route instead of the /dashboard/:id iframe.
  if (dashboard?.type === "Platform Dashboard") {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "EARNINGS_INTELLIGENCE",
      strictLogOnly ? undefined : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    recordRecent(dashboard, clientID, dispatch, strictLogOnly);
    if (dispatch) dispatch(setActiveDashboard({ ...dashboard, triggerType }));
    navigate && navigate(platformRoute(dashboard?.url, clientID, userDetails));
    return end();
  }
  if (dashboard?.type === "Static") {
    // if (!strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Static View MPF",
      userDetails,
      clientName,
      clientID,
      "PopUp Opened",
      strictLogOnly ? undefined : newTabId,
      strictLogOnly,
      "default"
    );
    if (strictLogOnly) return;
    if (!staticPop) {
      dispatch(setIsWebinarPopActive(true));
    }
    // window.open(dashboard?.url, "_blank");
    return end();
  }
  // console.log("handleItem check 5");
  // PDF/releasenote opens in PdfViewerPopup rather than navigating, so like
  // video it must not become the active dashboard - doing so re-renders the
  // dashboard page underneath to the release note while the popup shows it too.
  const opensInPopup =
    dashboard?.type === "video" ||
    dashboard?.type === "releasenote" ||
    dashboard?.type === "PDF";
if (dispatch) {
    dispatch(hideSalesPopUp());
    if (
      triggerType !== "NEWTAB_DASHBOARD" &&
      triggerType !== "NEWTAB_SIDEBAR_DASHBOARD" &&
      urlStatus !== "disabled" &&
      !opensInPopup
    )
      dispatch(setActiveDashboard({ ...dashboard, triggerType }));
}
  if (urlStatus !== "disabled" && dashboard?.type !== "video")
    recordRecent(dashboard, clientID, dispatch, strictLogOnly);
  // console.log("handleItem check 6");
  // Video type dashboard
  if (dashboard?.type === "video") {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "VIDEO",
      undefined,
      strictLogOnly,
      "default"
    );
    if (dispatch) {
      dispatch(setVideoPopupContent({ ...dashboard, triggerType }));
      dispatch(showVideoPopup());
    }
    if (strictLogOnly) return;
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    return end();
  }
  // console.log("handleItem check 7");
  // Disabled dashboard with sales content
  if (urlStatus === "disabled") {
    // console.log("disabled dashboard full object:", JSON.stringify(dashboard));
      console.log("=== DISABLED DASHBOARD BLOCK ===");
    console.log("dashboard full object:", dashboard?.label, dashboard?.url);
    console.log("salesContentId:", dashboard?.salesContentId);
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Disabled",
      userDetails,
      clientName,
      clientID,
      "SALES_CONTENT_POPUP",
      undefined,
      strictLogOnly,
      "default"
    );
    if (dispatch) {
    dispatch(setSalesPopupContent({ ...dashboard, triggerType }));
    dispatch(showSalesPopUp(triggerType));
}
    if (strictLogOnly) return;
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    // navigate && navigate(`/${clientID || ""}`);
    //  if (userDetails?.permissions === "HWAI_ADMIN" && clientID !== undefined && pathname !== `/${clientID}`) {
    //     navigate(`/${clientID}`);
    // } else if (pathname !== "/" && userDetails?.permissions !== "HWAI_ADMIN") {
    //     navigate("/");
    // }
    return end();
  }
  // console.log("handleItem check 8");
  // Check if dashboard is already active
  if (
    pathname &&
    (pathname?.includes(
      `/${clientID}/dashboard/${dashboard?._id}/${triggerType}`
    ) ||
      pathname?.includes(`/dashboard/${dashboard?._id}/${triggerType}`)) &&
    triggerType != "NEWTAB_SIDEBAR_DASHBOARD"
  ) {
    // console.log("handleItem - Already on the same dashboard");
    if (!strictLogOnly) return end();
    return end();
  }
  // console.log("handleItem check 9");
  // if ((triggerType === "NEWTAB_DASHBOARD" || triggerType === "NEWTAB_SIDEBAR_DASHBOARD" || triggerType === "EXTERNAL_LINK") && !strictLogOnly) await preNewTabNavigation()
  // console.log("handleItem check 10");
  callUserLogAPI(
    productLine,
    triggerType,
    dashboard?.label,
    dashboard?.standarddashboardId?.standardName,
    dashboard?._id,
    "Viewed",
    userDetails,
    clientName,
    clientID,
    triggerType === "EXTERNAL_LINK" ? "EXTERNAL_LINK" : "DASHBOARD",
    triggerType === "EXTERNAL_LINK" ||
      triggerType === "NEWTAB_DASHBOARD" ||
      triggerType === "NEWTAB_SIDEBAR_DASHBOARD"
      ? strictLogOnly
        ? undefined
        : newTabId
      : undefined,
    strictLogOnly,
    "default"
  );
  // console.log("handleItem check 11");
  if (triggerType === "EXTERNAL_LINK") {
    // window.open(dashboard?.url + `?${queryParams.toString()}`, "_blank");
    window.open(dashboard?.url, "_blank");
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    // if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 12");
  if (strictLogOnly) return;
  // console.log("handleItem check 13");
  if (
    triggerType === "NEWTAB_DASHBOARD" ||
    triggerType === "NEWTAB_SIDEBAR_DASHBOARD" ||
    triggerType === "NEWTAB_FLOATING_BUTTON"
  ) {
    let newtabUrl;
    if (userDetails?.permissions === "HWAI_ADMIN" && clientID !== undefined) {
      newtabUrl = `/${clientID}/dashboard/${dashboard?._id}/${triggerType}`;
    } else {
      newtabUrl = `/dashboard/${dashboard?._id}/${triggerType}`;
    }
    // window.open(newtabUrl + `?${queryParams.toString()}`, "_blank");
    window.open(newtabUrl, "_blank");
    if (setRefetchDynamicCampaigns)
      setRefetchDynamicCampaigns((cur) => cur + 1);
    return end();
  }
  // console.log("handleItem check 14");
  if (userDetails?.permissions === "HWAI_ADMIN" && clientID !== undefined) {
    openDashboardOrPdf(`/${clientID}/dashboard/${dashboard?._id}/${triggerType}`);
  } else {
    openDashboardOrPdf(`/dashboard/${dashboard?._id}/${triggerType}`);
  }
  if (setRefetchDynamicCampaigns) setRefetchDynamicCampaigns((cur) => cur + 1);
  return end();
}
async function handleLiveItemLog({
  productLine,
  dashboard,
  clientID,
  userDetails,
  clientName,
  triggerType,
  pathname,
  postItemHandle,
  dispatch,
  navigate,
  setRefetchDynamicCampaigns,
  strictLogOnly = false,
  pulseType = "default",
}) {
  // if (!strictLogOnly) if (dispatch) dispatch(startHandleItemLoading());
  const end = () => {
    // console.log("handleItem end");
    if (strictLogOnly) return;
    return;
  };
  const urlStatus = dashboard?.url?.toLowerCase();
  const hasSalesContent = dashboard?.salesContentId;
  // console.log("handleItem check 1");
  // handle whitepaper
  if (triggerType === "WHITEPAPER") {
    // if (dashboard?.type !== "releasenote" && !strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      dashboard?.type === "releasenote" ? "PDF" : "EXTERNAL_LINK",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 2");
  // Handle disabled dashboards without sales content
  if (
    urlStatus === "greyed" ||
    (urlStatus === "disabled" && !hasSalesContent)
  ) {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Disabled",
      userDetails,
      clientName,
      clientID,
      urlStatus === "greyed" ? "GREYED" : "NO_SALES_CONTENT",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 3");
  // Open dashboards in new tab
  if (dashboard?.type === "Open in new tab") {
    // if (!strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "EXTERNAL_LINK",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 4");
  // Data Cube handling
  if (dashboard?.type === "Data Cube") {
    // if (!strictLogOnly) await preNewTabNavigation()
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "EXTERNAL_LINK",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 5");
  // console.log("handleItem check 6");
  // Video type dashboard
  if (dashboard?.type === "video") {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Viewed",
      userDetails,
      clientName,
      clientID,
      "VIDEO",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 7");
  // Disabled dashboard with sales content
  if (urlStatus === "disabled") {
    callUserLogAPI(
      productLine,
      triggerType,
      dashboard?.label,
      dashboard?.standarddashboardId?.standardName,
      dashboard?._id,
      "Disabled",
      userDetails,
      clientName,
      clientID,
      "SALES_CONTENT_POPUP",
      undefined,
      true,
      pulseType
    );
    if (strictLogOnly) return;
    return end();
  }
  // console.log("handleItem check 8");
  // console.log("handleItem check 9");
  // console.log("handleItem check 10");
  callUserLogAPI(
    productLine,
    triggerType,
    dashboard?.label,
    dashboard?.standarddashboardId?.standardName,
    dashboard?._id,
    "Viewed",
    userDetails,
    clientName,
    clientID,
    triggerType === "EXTERNAL_LINK" ? "EXTERNAL_LINK" : "DASHBOARD",
    undefined,
    true,
    pulseType
  );
  // console.log("handleItem check 11");
  if (triggerType === "EXTERNAL_LINK") {
    return end();
  }
  // console.log("handleItem check 12");
  if (strictLogOnly) return;
  // console.log("handleItem check 13");
  if (
    triggerType === "NEWTAB_DASHBOARD" ||
    triggerType === "NEWTAB_SIDEBAR_DASHBOARD"
  ) {
    return end();
  }
  // console.log("handleItem check 14");
  return end();
}
export { handleItem, handleLiveItemLog };
